import React from 'react';
import { quietHoursMessage } from '../../lib/dialGuards.js';

/**
 * Quiet-hours intercept shown before a dial outside 8:00 AM – 8:00 PM prospect-local.
 * "Cancel Call" is the default/primary action.
 * @param {{info: {localTime?: string, zoneAbbr?: string}, onCancel: () => void, onConfirm: () => void}} props
 * @returns {JSX.Element}
 */
export default function TcpaQuietHoursModal({ info, onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-[1000] bg-black/70 flex items-center justify-center p-4" role="alertdialog" aria-modal="true" aria-label="Compliance warning" onClick={(e) => e.stopPropagation()}>
      <div className="panel max-w-md w-full p-5 space-y-4 border border-amber-500/50">
        <p className="text-sm text-white/90 leading-relaxed">
          <span aria-hidden="true">⚠️ </span>
          <strong>Compliance Warning:</strong> {quietHoursMessage(info)}
        </p>
        <div className="flex justify-end gap-2">
          <button type="button" autoFocus onClick={onCancel} className="px-4 py-2 rounded-md bg-civix-purple text-white text-sm font-semibold hover:bg-violet-500">
            Cancel Call
          </button>
          <button type="button" onClick={onConfirm} className="px-4 py-2 rounded-md border border-amber-500/50 text-amber-200 text-sm hover:bg-amber-500/10">
            Confirm &amp; Call Anyway
          </button>
        </div>
      </div>
    </div>
  );
}
